import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 從 localStorage 讀取購物車數據
const loadCartItems = () => {
  const savedCart = localStorage.getItem('cartItems')
  return savedCart ? JSON.parse(savedCart) : []
}

export default new Vuex.Store({
  state: {
    categories: ['Makeup', 'Cosmetics', 'Tools', 'SALE'],
    products: [
      {
        id: 1,
        name: '全效深層保濕柔膚水(平行輸入品)',
        collection: 'ESTEE LAUDER 雅詩蘭黛',
        price: 2790,
        salePrice: 1560,
        image: require('@/assets/img/product-1.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW', 'SALE'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' },
          { value: '#FF0000', name: 'Red' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 10
      },
      {
        id: 2,
        name: '升級再生基因修復精華(平行輸入品)',
        collection: 'ESTEE LAUDER 雅詩蘭黛',
        price: 180,
        salePrice: null,
        image: require('@/assets/img/product-2.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 15
      },
      {
        id: 3,
        name: '微精華活膚原生液(平行輸入品)',
        collection: 'ESTEE LAUDER 雅詩蘭黛',
        price: 200,
        salePrice: null,
        image: require('@/assets/img/product-3.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' },
          { value: '#FF0000', name: 'Red' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 20
      },
      {
        id: 4,
        name: 'SYNCHRO SKIN 柔霧妝前底霜(平行輸入品)',
        collection: 'SHISEIDO 資生堂',
        price: 1000,
        salePrice: 1280,
        image: require('@/assets/img/product-4.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW', 'SALE'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' },
          { value: '#FF0000', name: 'Red' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 10
      },
      {
        id: 5,
        name: '引釉眼線筆(平行輸入品)',
        collection: 'SHISEIDO 資生堂',
        price: 800,
        salePrice: null,
        image: require('@/assets/img/product-5.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' }
        ],
        sizes: ['1支裝', '3支裝'],
        stock: 15
      },
      {
        id: 6,
        name: '新艷陽．夏 防晒兩用粉餅 SPF 30(平行輸入品)',
        collection: 'SHISEIDO 資生堂',
        price: 1000,
        salePrice: null,
        image: require('@/assets/img/product-6.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' }
        ],
        sizes: ['1盒裝', '2盒裝'],
        stock: 20
      },
      {
        id: 7,
        name: '溫和去角質玫瑰凝膠(平行輸入品)',
        collection: '蘭蔻Lancôme',
        price: 1000,
        salePrice: 1200,
        image: require('@/assets/img/product-7.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW', 'SALE'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' },
          { value: '#FF0000', name: 'Red' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 10
      },
      {
        id: 8,
        name: '晶透潔顏泡沫(平行輸入品)',
        collection: '蘭蔻Lancôme',
        price: 1100,
        salePrice: null,
        image: require('@/assets/img/product-8.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 15
      },
      {
        id: 9,
        name: '超未來肌因賦活露(平行輸入品)',
        collection: '蘭蔻Lancôme',
        price: 4500,
        salePrice: null,
        image: require('@/assets/img/product-9.jpg'),
        images: [
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
          require('@/assets/img/product-1.jpg'),
        ],
        description: '',
        labels: ['NEW'],
        category: 'MAKEUP',
        colors: [
          { value: '#000000', name: 'Black' },
          { value: '#FFFFFF', name: 'White' },
          { value: '#FF0000', name: 'Red' }
        ],
        sizes: ['10 ML', '100 ML', '200 ML'],
        stock: 20
      }
    ],
    collections: [
      {
        id: 1,
        name: 'MAKEUP',
        image: require('@/assets/img/collection-1.png')
      },
      {
        id: 2,
        name: 'COSMETICS',
        image: require('@/assets/img/collection-2.png')
      },
      {
        id: 3,
        name: 'TOOLS',
        image: require('@/assets/img/collection-3.png')
      }
    ],
    news: [
      {
        id: 1,
        image: require('@/assets/img/news-1.jpg')
      },
      {
        id: 2,
        image: require('@/assets/img/news-2.jpg')
      },
    ],
    cartItems: loadCartItems(),
    shippingInfo: null
  },
  getters: {
    getProductsByCategory: (state) => (category) => {
      return state.products.filter(product => product.category === category)
    },
    getNewArrivals: (state) => {
      return state.products.filter(product => product.labels.includes('NEW'))
    },
    getSaleProducts: (state) => {
      return state.products.filter(product => product.labels.includes('SALE'))
    },
    getProductById: (state) => (id) => {
      return state.products.find(product => product.id === id)
    }
  },
  mutations: {
    addToCart(state, { product, color, size, quantity = 1 }) {
      const existingItem = state.cartItems.find(
        item => item.id === product.id && item.color === color && item.size === size
      )

      if (existingItem) {
        existingItem.quantity += quantity
      } else {
        state.cartItems.push({
          id: product.id,
          name: product.name,
          price: product.salePrice || product.price,
          image: product.image,
          color,
          size,
          quantity
        })
      }
      // 保存到 localStorage
      localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
    },
    removeFromCart(state, item) {
      const index = state.cartItems.findIndex(i => 
        i.id === item.id && 
        i.color === item.color && 
        i.size === item.size
      )
      if (index > -1) {
        state.cartItems.splice(index, 1)
        localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
      }
    },
    updateCartItemQuantity(state, { item, quantity }) {
      const cartItem = state.cartItems.find(i => 
        i.id === item.id && 
        i.color === item.color && 
        i.size === item.size
      )
      if (cartItem) {
        cartItem.quantity = quantity
        localStorage.setItem('cartItems', JSON.stringify(state.cartItems))
      }
    },
    setShippingInfo(state, info) {
      state.shippingInfo = info
    },
    clearCart(state) {
      state.cartItems = []
      localStorage.removeItem('cartItems')
    }
  },
  actions: {
  },
  modules: {
  }
}) 